<script setup>
const props = defineProps({
  title: {
    type: String,
    default: () => '',
  },
  description: {
    type: String,
    default: () => '',
  },
  duration: {
    type: Object,
    default: () => {},
  },
  url: {
    type: String,
    default: () => '',
  },
  view: {
    type: String,
    default: () => '',
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
const { getFormattedDates } = useDateTranslation();
const formattedDates = computed(() => {
  if (props.duration) {
    return getFormattedDates(props.duration);
  }
});
</script>
<template>
  <div
    :class="[
      'promo-content',
      backgroundColor === 'black' ? 'white' : 'black',
      `promo-content--${backgroundColor}`,
    ]"
  >
    <div class="promo-content__top">
      <p class="mb-0 promo-content__title promo-title" v-html="title"></p>
      <div
        class="promo-content__description body-3-regular"
        v-html="description"
      ></div>
    </div>
    <div class="promo-content__bottom">
      <div
        v-if="duration && (duration.start || duration.end) && formattedDates"
        class="promo-content__duration body-3-regular"
      >
        {{ $t('promotion.duration_start') }}
        <span
          v-if="formattedDates?.startDate || formattedDates?.endDate"
          class="promo-content__duration-time"
        >
          <template v-if="formattedDates.startDate">
            {{ $t('promotion.duration_from') }} {{ formattedDates.startDate }}
          </template>
          <template v-if="formattedDates.endDate">
            {{ $t('promotion.duration_between') }} {{ formattedDates.endDate }}
          </template>
        </span>
      </div>
      <Button v-if="url" v-slot="slotProps" as-child rounded>
        <CTagDetect
          :to="url"
          :class="[
            slotProps.class,
            'promo-content__button link-normal js-button-promo-slide',
            backgroundColor === 'black' ? 'button-white' : ' button-black',
          ]"
        >
          <template v-if="view === 'hero'">
            {{ $t('promotion.button_hero') }}
          </template>
          <template v-else>
            {{ $t('promotion.button') }}
          </template>
        </CTagDetect>
      </Button>
    </div>
  </div>
</template>
<style scoped lang="scss">
.promo-content {
  $parent: &;
  &--white {
    #{$parent} {
      &__description {
        background-color: $white;
        background-clip: content-box;
      }
    }
  }
  &--gray {
    #{$parent} {
      &__description {
        background-color: $gray;
        background-clip: content-box;
      }
    }
  }
  &--black {
    #{$parent} {
      &__description {
        background-color: rgba($surface-container-opacity, 0.5);
        background-clip: content-box;
      }
    }
  }
  &__top {
    @include media-breakpoint-up(md) {
      display: grid;
      grid-template-rows: 1fr 1fr;
      max-width: 33.8%;
      min-height: 368px;
      padding-right: 72px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-right, 72);
      @include responsive-spacing(min-height, 368);
    }
  }
  &__title {
    text-align: center;
    @include media-breakpoint-up(md) {
      text-align: left;
    }
  }
  &__description {
    margin-top: 24px;
    text-align: center;
    &:deep(p:last-child) {
      margin: 0;
    }
    @include media-breakpoint-up(sm) {
      margin: 32px auto 0;
      max-width: 55%;
    }
    @include media-breakpoint-up(md) {
      margin: 0;
      max-width: unset;
      padding-top: 42px;
      text-align: left;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(padding-top, 42);
    }
  }
  &__bottom {
    align-items: center;
    display: flex;
    flex-direction: column;
    @include media-breakpoint-up(sm) {
      align-items: end;
      display: grid;
      gap: 24px;
      grid-template-columns: 3fr 6fr 3fr;
      margin-top: 56px;
      min-height: 48px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(margin-top, 56);
      @include responsive-spacing(gap, 24);
      @include responsive-spacing(min-height, 48);
    }
  }
  &__duration {
    margin-top: 16px;
    text-align: center;
    @include media-breakpoint-up(sm) {
      margin-top: 0;
      text-align: left;
      &-time {
        white-space: nowrap;
      }
    }
  }
  &__button {
    margin-top: 24px;
    @include media-breakpoint-up(sm) {
      margin-top: 0;
      justify-self: center;
      width: fit-content;
    }
  }
}
</style>
